module.exports = __webpack_public_path__ + "static_pest_wiki_details/img/quick-icon-c.c58fc0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/resources/quick-icon-c.png
// module id = Fmf7
// module chunks = 3 5